import { genericRequest } from "./genericRequest";

export async function getById(route, id) {
  const url = `${route}Get/${id}`;
  return genericRequest("GET", url);
}

export async function getByName(route, name) {
  const url = `${route}${name}`;
  return genericRequest("GET", url);
}

export async function get(route) {
  const url = `${route}Get`;
  return genericRequest("GET", url);
}

export async function update(route, event) {
  const url = `${route}Update`;
  return genericRequest("POST", url, null, event);
}

export async function insert(route, event) {
  const url = `${route}Insert`;
  return genericRequest("POST", url, null, event);
}

export async function post(route, event) {
  const url = `${route}Post`;
  return genericRequest("POST", url, null, event);
}

export async function remove(route, event) {
  const url = `${route}Remove`;
  return genericRequest("POST", url, null, event);
}

export function puntToSignIn() {
  const url = new URL(window.location.href);
  let relative = url.pathname + url.search + url.hash;
  if (relative.startsWith('/auth/sign-in'))
    relative = '';
  window.location.href = "/auth/sign-in?then=" +
    (relative ? encodeURIComponent(relative) : '');
  return Promise.reject();
}
